import React from 'react';
import { IProps as IStatsCardBlockProps, IStatsCard } from './StatsCardBlock.interface';
import { StatsCardBlock } from './StatsCardBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IStatsCardBlockInputProps {
    heading?: string;
    description?: string;
    layout?: 'horizontal' | 'vertical';
    items?: {
        icon?: string;
        heading?: string;
        summary?: string;
    }[];
    buttons?: any[];
    background?: string;
    showIcons?: boolean;
    text?: string | null;
    [key: string]: any;
}

const mapInputToProps = (input: IStatsCardBlockInputProps): IStatsCardBlockProps => {
    const { heading, description, icon, items, layout, buttons, background, showIcons, text, ...rest } = input;
    return {

        title: heading || undefined,
        description: description || undefined,
        stats: items?.map((item) => ({
            icon: item.icon || undefined,
            stat: item.heading || undefined,
            description: item.summary || undefined,
        })) as IStatsCard[],
        statsLayout: layout || 'vertical',
        notes: text || undefined,
        buttons: buttons && buttons.length > 0 ? buttons.map((button: any) => translation.mapAnchorProps(button)) : undefined,
        backgroundColor: background || 'white',
        ...rest
    };
};

const StatsCardBlockTranslation: React.FC<IStatsCardBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={StatsCardBlock}
        mapProps={mapInputToProps}
    />
);

export default StatsCardBlockTranslation;
